export const LAST_SEEN_CHANGELOG_VERSION = 'LAST_SEEN_CHANGELOG_VERSION';
export const LAST_SEEN_UNRELEASED_FINGERPRINT = 'LAST_SEEN_UNRELEASED_FINGERPRINT';
